import styled from '@emotion/styled'

export const TransparencyItemTextContainer = styled.div({
  flexGrow: 1,
  textAlign: 'center',
})
